import React from "react";

export default function Footer() {
  return (
    <footer>
      <div id="forecast"></div>
    </footer>
  );
}
